export const FIELD_DEFINITIONS = {
  SIGNATURE: "SIGNATURE",
  FILE_UPLOAD: "FILE_UPLOAD",
  DATE: "DATE",
  DATE_TIME_SELECT: "DATE_TIME_SELECT",
};
